import * as React from 'react';

import {ErrorMessage} from 'shells/form/error-message';
import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import {Field} from 'redux-form';

import {TinyIntroTextField} from '../../fields/tiny-intro-text-field';

import {LOGIN_FORM_PASSWORD_FIELD} from '../login-form';

import {LoginFlowButton} from './login-flow-button';
import {OptionsSection} from './options-section';

type Props = {
    handleSubmit: (formValues: any) => undefined | Promise<any>;
    submitting: boolean;
    valid: boolean;
    emailValue: string | null | undefined;
    submitFailed: boolean;
    error: string | null | undefined;
};

export function PasswordLoginPage(props: Props) {
    return (
        <form onSubmit={props.handleSubmit}>
            <Header>Sign in</Header>
            <Subheader>
                You are signing in as{' '}
                <Body size='large' wrapAnywhere={true}>
                    {props.emailValue}
                </Body>
            </Subheader>
            <div className='mt-24'>
                <Field
                    key='password'
                    name={LOGIN_FORM_PASSWORD_FIELD}
                    placeholder='··········'
                    title='Password'
                    type='password'
                    autoFocus={true}
                    autocomplete={true}
                    component={TinyIntroTextField}
                    variant='redux-form'
                />
            </div>
            <LoginFlowButton
                bttnVariant={props.valid ? 'primary' : 'secondary'}
                submitting={props.submitting}
            />
            {props.submitFailed && props.error && (
                <div className='my-16'>
                    <ErrorMessage>{props.error}</ErrorMessage>
                </div>
            )}
            <OptionsSection emailValue={props.emailValue} />
        </form>
    );
}
